/**
 * Méthodes de validation yup personnalisées
 * Reproduites de nec-front/packages/forms/src/yupValidationMethods.tsx
 */
import * as yup from 'yup';

// Regex pour email avec TLD obligatoire (min 2 caractères après le dernier point)
const emailRegex = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,18}$/;

// Validation alphanumerique avec accents
yup.addMethod(yup.string, 'alphaNumeric', function (message?: string) {
    return this.matches(/^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]+$/i, { message, excludeEmptyString: true });
});

// Validation pour les caractères d'adresse (lettres, chiffres, -, /, ', espaces)
yup.addMethod(yup.string, 'alphaNumericOrAddressChars', function (message?: string) {
    return this.test({
        name: 'alphaNumericOrAddressChars',
        message,
        test(value: string | undefined) {
            if (!value || value === '') return true;
            // Doit commencer et finir par un caractère alphanumérique
            const startsWithAlphanumeric = /^[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(value);
            const endsWithAlphanumeric = /[0-9A-Za-zÀ-ÖØ-öø-ÿ]$/.test(value);
            const containsOnlyValidChars = /^[0-9A-Za-zÀ-ÖØ-öø-ÿ\-/'\s]+$/.test(value);
            return startsWithAlphanumeric && endsWithAlphanumeric && containsOnlyValidChars;
        },
    });
});

// Validation téléphone nord-américain (format: 514-555-1234 ou 5145551234)
yup.addMethod(yup.string, 'telephone', function (message?: string) {
    return this.test({
        name: 'telephone',
        message,
        test(value: string | undefined) {
            if (!value || value === '') return true;
            // Doit contenir exactement 10 chiffres
            return value.replace(/\D/g, '').length === 10;
        },
    });
});

// Validation email stricte avec TLD obligatoire
yup.addMethod(yup.string, 'emailStrict', function (message?: string) {
    return this.test({
        name: 'emailStrict',
        message,
        test(value: string | undefined) {
            if (!value || value === '') return true;
            return emailRegex.test(value.trim());
        },
    });
});

// Déclaration TypeScript pour les méthodes ajoutées
declare module 'yup' {
    interface StringSchema {
        alphaNumeric(message?: string): StringSchema;
        alphaNumericOrAddressChars(message?: string): StringSchema;
        telephone(message?: string): StringSchema;
        emailStrict(message?: string): StringSchema;
    }
}

export { };
